import { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import PublishIcon from '@mui/icons-material/Publish';
import { publishDashboardVersion } from './actions/publishActions';

/**
 * PublishButton - כפתור פרסום (סטנד-אלון)
 * 
 * Business Component - מקבל dispatch ונתונים דרך props, מזמן את ה-action בעצמו
 * 
 * @param {string} dashboardId - מזהה הדשבורד
 * @param {boolean} hasUnsavedChanges - האם יש שינויים שלא נשמרו
 * @param {function} dispatch - Redux dispatch function
 * @param {boolean} fullWidth - האם הכפתור ברוחב מלא
 * @param {function} onSuccess - callback להצלחה
 * @param {function} onError - callback לשגיאה
 */
const PublishButton = ({ dashboardId, hasUnsavedChanges, dispatch, fullWidth = false, onSuccess, onError }) => {
    const [isPublishing, setIsPublishing] = useState(false);

    const handlePublish = async (e) => {
        if (e) e.stopPropagation();

        if (!dashboardId || isPublishing || hasUnsavedChanges) return;

        try {
            setIsPublishing(true);

            console.log('📤 PublishButton - Publishing dashboard:', dashboardId);

            await dispatch(publishDashboardVersion(dashboardId, null, null));

            console.log('✅ PublishButton - Dashboard published successfully');
            onSuccess?.();
        } catch (error) {
            console.error('❌ PublishButton - Error publishing dashboard:', error);
            onError?.(error.message || 'שגיאה בפרסום הלוח');
        } finally {
            setIsPublishing(false);
        }
    };

    return (
        <Button
            fullWidth={fullWidth}
            variant="contained"
            startIcon={isPublishing ? <CircularProgress size={16} sx={{ color: 'white' }} /> : <PublishIcon />}
            onClick={handlePublish}
            disabled={isPublishing || hasUnsavedChanges}
            sx={{
                background: 'linear-gradient(135deg, #9a7209 0%, #c8960c 100%)',
                color: 'white',
                fontWeight: 600,
                px: 2,
                py: 0.5,
                fontSize: '0.875rem',
                borderRadius: '12px',
                textTransform: 'none',
                minHeight: '36px',
                boxShadow: '0 2px 8px rgba(154,114,9,0.3)',
                transition: 'all 0.2s',
                '&:hover': {
                    background: 'linear-gradient(135deg, #7a5a07 0%, #9a7209 100%)',
                    boxShadow: '0 4px 16px rgba(154,114,9,0.45)',
                    transform: 'translateY(-1px)'
                },
                '&.Mui-disabled': {
                    bgcolor: 'rgba(154,114,9,0.3)',
                    color: 'rgba(255,255,255,0.5)'
                },
                gap: 1
            }}
        >
            {isPublishing ? 'מפרסם...' : hasUnsavedChanges ? 'שמור לפני פרסום' : 'פרסום גירסה'}
        </Button>
    );
};

export default PublishButton;
